<!--
  Specialization of ElColorableInput for response
-->

<script>
import ElColorableInput from './ElColorableInput.vue'
import ElColorableAutocomplete from './ElColorableAutocomplete.vue'

const ElResponseInput = {
  name: 'ElResponseInput',
  extends: ElColorableInput,

  data () {
    return {
      suggestion: null,
    }
  },
  watch: {
    suggestion (val) {
      this.$emit('suggestion', val)
    },
    position () {
      // saves a suggestion for later, if the user presses "down"
      this.handleSuggestion(false)
    },
  },

  mounted () {
    // display suggestion if the user it typing a variable
    this.$on('userupdate', () => {
      this.handleSuggestion(true)
    })
  },

  methods: {
    // parses $ and @ variables
    fromExpression (expression) {
      const segs = []
      expression.replace(/([^$@{}]+)|([$@])([^$@\s{}]*)|\{([^$@{}]+)\}|([{}])/g,
        (_, text, prefix, name, tuned, invalid) => {
          if (text) {
            segs.push({
              type: 'text',
              text: text,
              key: Math.random() + '',
            })
          } else if (prefix) {
            segs.push({
              type: prefix === '@' ? 'local' : 'context',
              text: name,
              key: Math.random() + '',
            })
          } else if (tuned) {
            segs.push({
              type: 'tuned',
              text: tuned,
              key: Math.random() + '',
            })
          } else if (invalid) {
            segs.push({
              type: 'invalid',
              text: invalid,
              key: Math.random() + '',
            })
          }
          return ''
        })
      return segs
    },
    // turns back into string
    toExpression (segs) {
      return segs.map((seg) => {
        if (seg.type === 'local') return '@' + seg.text
        else if (seg.type === 'context') return '$' + seg.text
        else if (seg.type === 'tuned') return '{' + seg.text + '}'
        else return seg.text
      }).join('')
    },
    // look for @ and $ for new variables
    parseText ({ text, key }, methods) {
      text.replace(/([^$@{}]+)|([$@])([^$@\s{}]*)|\{([^$@{}]+)\}|([{}])/g,
        (_, text, prefix, name, tuned, invalid) => {
          if (text) {
            methods.push_text(text, key)
            key = null
          } else if (prefix) {
            methods.push_seg({
              type: prefix === '@' ? 'local' : 'context',
              text: name,
              key: methods.get_key(),
            })
          } else if (tuned) {
            methods.push_seg({
              type: 'tuned',
              text: tuned,
              key: Math.random() + '',
            })
          } else if (invalid) {
            methods.push_seg({
              type: 'invalid',
              text: invalid,
              key: Math.random() + '',
            })
          }
          return ''
        })
    },
    // check that it is still looking like a variable
    parseVariable (attrs, methods) {
      let m = attrs.text.match(/(.*\s)?([@$])(\S+)(\s.*)?/)
      if (!m) {
        methods.push_text(attrs.text)
        return
      }
      if (m[1]) methods.push_text(m[1])
      methods.push_seg({
        type: m[2] === '@' ? 'local' : 'context',
        text: m[3],
        key: attrs.key,
      })
      if (m[4]) methods.push_text(m[4])
    },
    parseLocal (attrs, methods) { return this.parseVariable(attrs, methods) },
    parseContext (attrs, methods) { return this.parseVariable(attrs, methods) },

    parseTuned (attrs, methods) {
      let m = attrs.text.match(/([^{}]*)\{([^$@{}]+)\}([^{}]*)/)
      if (!m) {
        methods.push_text(attrs.text)
        return
      }
      if (m[1]) methods.push_text(m[1])
      methods.push_seg({
        type: 'tuned',
        text: m[2],
        key: attrs.key,
      })
      if (m[3]) methods.push_text(m[3])
    },
    parseInvalid (attrs, methods) { methods.push_text(attrs.text) },
    // adds @ in front
    renderLocal (seg, el, attrs) {
      return el.text('@' + seg.text).attr(attrs)
    },
    // adds $ in front
    renderContext (seg, el, attrs) {
      return el.text('$' + seg.text).attr(attrs)
    },
    // adds {} around
    renderTuned (seg, el, attrs) {
      if (!seg.text || seg.text[0].match(/\s/) ||
        seg.text[seg.text.length - 1].match(/\s/)) {
        el.addClass('el-colorable__invalid')
      }
      return el.text('{' + seg.text + '}').attr(attrs)
    },
    // calls to check for a new suggestion
    // input = true if it comes from a user input
    handleSuggestion (input) {
      let pos = this.position, suggestion = null
      if (!pos.key) return
      // a variable, suggestion using the current variable name as query
      // the suggestion should be placed under the variable
      if (pos.type && pos.type !== 'text') {
        suggestion = {
          input: input,
          type: pos.type,
          query: pos.text.substr(1),
          key: pos.key,
          x: pos.el && pos.el.offset().left + pos.el.width() / 2,
        }
      }
      // no suggestion for the cursor, close the suggestion
      if (!suggestion) this.suggestion = null
      // suggestion on input, open suggestions
      else if (input) this.suggestion = suggestion
      // no previous suggestion opened, keep suggestion for "down" pressed
      else if (!this.suggestion || !this.suggestion.input) {
        this.suggestion = suggestion
      // suggestion on a different variable, close and replace the current one
      } else if (suggestion.key !== this.suggestion.key ||
          suggestion.type === 'text' && suggestion.left !== this.suggestion.left) {
        this.suggestion = suggestion
      }
    },
    // inserts a variable name on a suggestion
    setVariable (query, value) {
      if (!query || !value) return
      let out = [], pos = this.position.key === query.key && this.position.absolute
      this.copySegments.forEach(seg => {
        if (query.key === seg.key) {
          if (seg.type !== 'text') {
            out.push({ ...seg, text: value })
            if (pos) {
              pos += value.length + 1 - this.position.left
            }
          } else {
            if (query.left > 1) {
              out.push({
                type: 'text',
                key: seg.key,
                text: seg.text.substr(0, query.left - 1),
              })
            }
            out.push({
              type: query.type,
              key: Math.random() + '',
              text: value,
            })
            if (query.left < seg.text.length) {
              out.push({
                type: 'text',
                key: seg.key,
                text: seg.text.substr(query.left),
              })
            }
            if (pos) {
              pos += query.left + value.length - this.position.left
            }
          }
        } else out.push(seg)
      })
      this.copySegments = out
      // rerender the contenteditable div
      this.renderHTML()
      this.setPosition(pos || this.position.absolute)
      // emit an event
      this.$emit('update:segments', this.copySegments)
      // update expression
      this.copyExpression = this.toExpression(this.copySegments)
    },
  },
}

export default {
  name: 'ElResponseAutocomplete',
  extends: ElColorableAutocomplete,
  props: {
    input: {
      default: () => ElResponseInput,
    },
  },
}
</script>

<style lang="scss">
  @import "../../element-variables.scss";

  /* style of response variables */
  .el-colorable__local {
    background-color: $entity-bg-color;
  }
  .el-colorable__context {
    background-color: $variable-bg-color;
  }
  .el-colorable__tuned {
    font-style: italic;
  }
  .el-colorable__invalid {
    font-style: italic;
    color: $--color-danger;
    // border-bottom: 2px dotted red;
  }
</style>
